import { createSelector } from 'reselect';

import { FLAG_KEYS } from 'lib/constants';
import { getLaunchDarklyFlags } from './getLaunchDarklyFlags';

// Submit Unattended tickets through the zero-parts modal instead of the full
// labor ticket form. Independent of Skip Setup Parts, which some shops need
// off so operators can report setup scrap.
const getUnattendedSkipLaborTicketFormEnabled = createSelector(
  [getLaunchDarklyFlags],
  (flags) => {
    return (
      flags?.[FLAG_KEYS.UNATTENDED_SKIP_LABOR_TICKET_FORM_ENABLED] === true
    );
  }
);

export { getUnattendedSkipLaborTicketFormEnabled };
